import {
  listSourceGDAs_DDAs,
  listSourceVariantAll_VDAs,
  listSourceAcademic,
  listSourceDiseaseAll,
  listSourceGeneALL,
  listSourceChemicalAll,
} from './tableHelpers';

const variantSourceButtons = ['VARIANTS', 'VDA'];
const diseasesSourceButtons = ['DISEASES'];
const genesSourceButtons = ['GENES'];
const gdaDDASourceButtons = ['GDA', 'DDA'];
const chemicalSourceButtons = ['CHEMICALS'];

export function isSourceEnabledForTab(source, tab, restrictSources: string | false | null = null) {
  if (restrictSources === 'CURATED' && !isValidCuratedSource(source, tab)) {
    return false;
  }

  const tabsnotchem = ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'];
  const tabsWithClingen = tabsnotchem;
  const tabsWithClinvar = tabsnotchem;
  const tabsWithClinpgx = tabsnotchem.concat(['CHEMICALS']);
  const tabsWithFinngen = tabsnotchem;
  const tabsWithUkbiobank = tabsnotchem;
  const tabsWithTextminingModels = tabsnotchem.concat(['CHEMICALS']);
  const tabsWithGencc = ['GDA', 'DDA', 'DISEASES', 'GENES', 'VARIANTS'];
  const tabsWithGwascat = ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'];
  const tabsWithPhewascat = ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'];
  const tabsinCommon = ['GDA', 'DDA', 'DISEASES', 'GENES'];
  const tabsWithHPO = tabsinCommon;
  const tabsWithInferred = tabsinCommon;
  const tabsWithMGDMouse = tabsinCommon;
  const tabsWithMGDHuman = tabsinCommon;
  const tabsWithRGDRat = tabsinCommon;
  const tabsWithRGDHuman = tabsinCommon;
  const tabsWithPsygenet = tabsinCommon;
  const tabsWithOrphanet = tabsinCommon;
  const tabsWithModels = ['GDA', 'DDA', 'DISEASES', 'GENES', 'CHEMICALS'];
  const tabsWithBiobank = ['GDA', 'DDA', 'VDA', 'DISEASES', 'GENES', 'VARIANTS'];
  const tabsWithClinicaltrials = ['GDA', 'DDA', 'DISEASES', 'GENES', 'CHEMICALS'];
  const tabsWithTextminingHuman = tabsnotchem.concat(['CHEMICALS']);
  const tabsWithUniprot = tabsnotchem;
  const tabsWithChembl = ['GDA', 'DDA', 'CHEMICALS'];

  if (source === 'CHEMBL' && !tabsWithChembl.includes(tab)) {
    return false;
  }
  if (source === 'CLINGEN' && !tabsWithClingen.includes(tab)) {
    return false;
  }
  if (source === 'GENCC' && !tabsWithGencc.includes(tab)) {
    return false;
  }
  if (source === 'CLINVAR' && !tabsWithClinvar.includes(tab)) {
    return false;
  }
  if (source === 'CLINPGX' && !tabsWithClinpgx.includes(tab)) {
    return false;
  }
  if (source === 'GWASCAT' && !tabsWithGwascat.includes(tab)) {
    return false;
  }
  if (source === 'PHEWASCAT' && !tabsWithPhewascat.includes(tab)) {
    return false;
  }
  if (source === 'HPO' && !tabsWithHPO.includes(tab)) {
    return false;
  }
  if (source === 'FINNGEN' && !tabsWithFinngen.includes(tab)) {
    return false;
  }
  if (source === 'UKBIOBANK' && !tabsWithUkbiobank.includes(tab)) {
    return false;
  }
  if (source === 'INFERRED' && !tabsWithInferred.includes(tab)) {
    return false;
  }
  if (source === 'MODELS' && !tabsWithModels.includes(tab)) {
    return false;
  }
  if (source === 'BIOBANK' && !tabsWithBiobank.includes(tab)) {
    return false;
  }
  if (source === 'MGD_MOUSE' && !tabsWithMGDMouse.includes(tab)) {
    return false;
  }
  if (source === 'MGD_HUMAN' && !tabsWithMGDHuman.includes(tab)) {
    return false;
  }
  if (source === 'TEXTMINING_MODELS' && !tabsWithTextminingModels.includes(tab)) {
    return false;
  }
  if (source === 'TEXTMINING_HUMAN' && !tabsWithTextminingHuman.includes(tab)) {
    return false;
  }
  if (source === 'ORPHANET' && !tabsWithOrphanet.includes(tab)) {
    return false;
  }
  if (source === 'RGD_RAT' && !tabsWithRGDRat.includes(tab)) {
    return false;
  }
  if (source === 'RGD_HUMAN' && !tabsWithRGDHuman.includes(tab)) {
    return false;
  }
  if (source === 'PSYGENET' && !tabsWithPsygenet.includes(tab)) {
    return false;
  }
  if (source === 'CLINICALTRIALS' && !tabsWithClinicaltrials.includes(tab)) {
    return false;
  }
  if (source === 'UNIPROT' && !tabsWithUniprot.includes(tab)) {
    return false;
  }

  return true;
}

export function isValidCuratedSource(source, tab) {
  if (variantSourceButtons.includes(tab)) {
    return listSourceVariantAll_VDAs.CURATED.includes(source);
  }
  if (diseasesSourceButtons.includes(tab)) {
    return listSourceDiseaseAll.CURATED.includes(source);
  }
  if (genesSourceButtons.includes(tab)) {
    return listSourceGeneALL.CURATED.includes(source);
  }
  if (gdaDDASourceButtons.includes(tab)) {
    return listSourceGDAs_DDAs.CURATED.includes(source);
  }
  if (chemicalSourceButtons.includes(tab)) {
    return listSourceChemicalAll.CURATED.includes(source);
  }
  return source === 'CURATED';
}

function cleanCuratedSources(sources, tab) {
  return sources;
}

export function getSourceList({ tab, restrictSources }) {
  if (restrictSources === 'CURATED') {
    if (variantSourceButtons.includes(tab)) {
      return { CURATED: listSourceVariantAll_VDAs.CURATED };
    }
    if (diseasesSourceButtons.includes(tab)) {
      return { CURATED: listSourceDiseaseAll.CURATED };
    }
    if (genesSourceButtons.includes(tab)) {
      return { CURATED: listSourceGeneALL.CURATED };
    }
    if (gdaDDASourceButtons.includes(tab)) {
      return { CURATED: listSourceGDAs_DDAs.CURATED };
    }
    return listSourceAcademic;
  }

  if (variantSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceVariantAll_VDAs };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (diseasesSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceDiseaseAll };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (genesSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceGeneALL };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (gdaDDASourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceGDAs_DDAs };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  if (chemicalSourceButtons.includes(tab)) {
    const sourcesObj = { ...listSourceChemicalAll };
    if (sourcesObj.CURATED) {
      sourcesObj.CURATED = cleanCuratedSources(sourcesObj.CURATED, tab);
    }
    return sourcesObj;
  }
  return [];
}
